import { useMemo } from 'react';
import { useAuth } from './use-auth';
import { AdminRoles } from '@/lib/types';

export default function useIsMasterAdmin(): boolean {
  const { role } = useAuth();

  return useMemo(() => {
    return !!role && role.id === AdminRoles.MasterAdmin;
  }, [role]);
}
